module.exports = __webpack_public_path__ + "img/module4.58055e6.png";